import React from 'react';
import './novacalib.css';

function NovaCalib(){
    return <div>
      <h1>Em Construção</h1>
    </div>
  }

export default NovaCalib;